import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Grid } from "@mui/material";
import Player from "../../../components/video-player/Player";
import VideoAnalysisPlayer from "e.sic-platform.webclient/src/components/video-player/VideoAnalysisPlayer";
import VideoTools from "e.sic-platform.webclient/src/pages/analysis/components/video-analysis-diagram/tools/VideoTools";
import { AnalysisConfidenceStorageModel } from "e.sic-platform.webclient/src/services/organization-analysis-confidence/AnalysisConfidenceStorage";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import { SegmentationService } from "e.sic-platform.webclient/src/services/segmentation/SegmentationService";
import { PubSubEvents } from "e.sic-platform.webclient/src/services/PubSubEvents";

interface IVideoSegmentationPlayerProps {
  videoSegmentation: SegmentationService;
}

export default observer(function VideoSegmentationPlayer(props: IVideoSegmentationPlayerProps) {
    const { videoSegmentation } = props;
    const [confidenceStorage] = useState(() =>
       AnalysisConfidenceStorageModel.create({ autoLoad: false }, { api })
     );

    useEffect(() => {
      if (videoSegmentation.fileId === undefined) return;
      var segmentationSubscribeToken = PubSub.subscribe(
        PubSubEvents.VideoSegmentationFinished,
        async (_event: string, notification: Notification) => {
          videoSegmentation.onServiceFinished(notification.data.fileId);
        }
      );
    }, [videoSegmentation.onServiceFinished, videoSegmentation.fileId]);

    if (!videoSegmentation) return null;

    return(
        <>
        {videoSegmentation?.segmentationSuccessful && (
          <Grid item xs={12} xl={4} className="centered" sx={{display: {xs: "flex", xl: "none"}}}>
            <div className="legends-container">
              <VideoTools
                videoSegmentation={videoSegmentation!}
                analysisConfidenceStorage={confidenceStorage}
              />
            </div>
          </Grid>
        )}
        <Grid item xs={12} xl={8}>
          <Player service={videoSegmentation!}>
            {videoSegmentation.video?.isAvailable && <VideoAnalysisPlayer videoSegmentation={videoSegmentation}/>}
          </Player>
        </Grid>
        {videoSegmentation?.segmentationSuccessful && (
          <Grid item xs={12} xl={4} className="centered" sx={{display: {xs: "none", xl: "flex"}}}>
            <div className="legends-container">
              <VideoTools
                videoSegmentation={videoSegmentation!}
                analysisConfidenceStorage={confidenceStorage}
              />
            </div>
          </Grid>
        )}
        </>
        )
    }
);